import { useLocation } from 'react-router-dom';
import Layout from '../../components/layout';

type ViewState = { reportId: string; }
//type Params = { id: string; };

const ReportPowerBi = () => {
  const { state } = useLocation<ViewState>();
  //const { id } = useParams<Params>();

  return (
    <Layout>
      <>
        {state && state !== undefined && state !== null && (
          <>
            {state.reportId !== undefined && state.reportId !== null && (
              <iframe
                title="TEST"
                width="1140"
                height="541.25"
                src={`https://app.powerbi.com/reportEmbed?reportId=${state.reportId}&autoAuth=true&ctid=2fe71b16-e31d-4bfd-8cb2-6cc71358b0e4&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLWVhc3QyLWItcHJpbWFyeS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D`}
                frameBorder={0}
                allowFullScreen={true}
              ></iframe>
            )}

            {state.reportId === undefined && state.reportId == null && <h3>No Report ID Found</h3>}
          </>
        )}

        {(!state || state === undefined || state === null) && <h3>No Report ID Found</h3>}
      </>
    </Layout>
  );
};

export default ReportPowerBi;
